import { MouseEventHandler } from 'react';

export const RadioButton = ({
  label,
  checked,
  onClick,
  children,
}: {
  label?: string;
  checked: boolean;
  onClick: MouseEventHandler;
  children?: React.ReactNode;
}) => {
  return (
    <button
      onClick={onClick}
      className="flex h-fit w-fit cursor-pointer select-none items-center gap-[.8rem] rounded-full"
      type="button"
    >
      <div
        className={`h-[1.6rem] w-[1.6rem] overflow-clip rounded-full outline outline-1 outline-brand-secondary`}
      >
        {checked && (
          <div className="h-[1.6rem] w-[1.6rem] rounded-full border-[.25rem] border-brand-white bg-brand-secondary" />
        )}
      </div>
      {label} {children}
    </button>
  );
};

export default RadioButton;
